"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROARR = exports.Roarr = exports.logLevels = exports.getLogLevelName = void 0;
const boolean_1 = require("boolean");
const fast_json_stringify_1 = __importDefault(require("fast-json-stringify"));
const fast_safe_stringify_1 = __importDefault(require("fast-safe-stringify"));
const globalthis_1 = __importDefault(require("globalthis"));
const constants_1 = require("./constants");
Object.defineProperty(exports, "logLevels", { enumerable: true, get: function () { return constants_1.logLevels; } });
const createLogger_1 = require("./factories/createLogger");
const createMockLogger_1 = require("./factories/createMockLogger");
const createRoarrInitialGlobalState_1 = require("./factories/createRoarrInitialGlobalState");
const getLogLevelName_1 = require("./getLogLevelName");
Object.defineProperty(exports, "getLogLevelName", { enumerable: true, get: function () { return getLogLevelName_1.getLogLevelName; } });
const fastStringify = (0, fast_json_stringify_1.default)({
    properties: {
        message: {
            type: 'string',
        },
        sequence: {
            type: 'string',
        },
        time: {
            type: 'integer',
        },
        version: {
            type: 'string',
        },
    },
    type: 'object',
});
const globalThis = (0, globalthis_1.default)();
const ROARR = globalThis.ROARR = (0, createRoarrInitialGlobalState_1.createRoarrInitialGlobalState)(globalThis.ROARR || {});
exports.ROARR = ROARR;
let logFactory = createLogger_1.createLogger;
// eslint-disable-next-line node/no-process-env
const enabled = (0, boolean_1.boolean)((_a = process.env.ROARR_LOG) !== null && _a !== void 0 ? _a : '');
if (!enabled) {
    logFactory = createMockLogger_1.createMockLogger;
}
const serializeMessage = (message) => {
    return '{"context":' + (0, fast_safe_stringify_1.default)(message.context) + ',' + fastStringify(message).slice(1);
};
const Roarr = logFactory((message) => {
    var _a;
    if (ROARR.write) {
        // Stringify message as soon as it is received to prevent
        // properties of the context from being modified by reference.
        ROARR.write(((_a = ROARR.serializeMessage) !== null && _a !== void 0 ? _a : serializeMessage)(message));
    }
});
exports.Roarr = Roarr;
